<div *transloco="let t">
	<div class="card flex flex-row flex-wrap" style="background-color: transparent; box-shadow: none">
		@if (layoutService.isMobile() || layoutService.isTablet()) {
			<ng-container>
				<div class="flex flex-row justify-center items-center" @fadeInUp>
					<div class="flex flex-col justify-center items-center">
						<swiper-container slides-per-view="1" class="slide-box" loop="true" pagination="true">
							<swiper-slide>
								<div class="detail-card info-text">
									<h3>{{ t('tenantunitDetailsCards.servicecompany') }}</h3>
									<ng-template *ngTemplateOutlet="companyDetailCardMobile; context: { $implicit: selectedServiceCompany() }"></ng-template>
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="detail-card info-text">
									<h3>{{ t('tenantunitDetailsCards.propertymanagement') }}</h3>
									@if (selectedPropertyManagement() === undefined) {
										<div class="flex justify-center py-2"><mat-spinner diameter="24" color="primary"></mat-spinner></div>
									} @else {
										<p>{{ selectedPropertyManagement()?.name ?? selectedPropertyManagement()?.addressField1 }}</p>
										<p>{{ selectedPropertyManagement()?.addressField2 }}</p>
										<p>{{ selectedPropertyManagement()?.street }} {{ selectedPropertyManagement()?.houseNumber }}</p>
										<p>{{ selectedPropertyManagement()?.zipCode }} {{ selectedPropertyManagement()?.city }}</p>
									}
								</div>
							</swiper-slide>
							<swiper-slide>
								<div class="detail-card info-text">
									@if (selectedRealEstate() === undefined) {
										<div class="flex justify-center py-4"><mat-spinner diameter="24" color="primary"></mat-spinner></div>
									} @else {
										<h3>
											{{ t('tenantunitDetailsCards.lsNr') }}
											{{ selectedRealEstate()?.area }}
											/{{ selectedRealEstate()?.number }}
										</h3>
										<p>
											{{ selectedRealEstate()?.address?.streets[0]?.streetName }}
											{{ selectedRealEstate()?.address?.streets[0]?.houseNumber }}
										</p>
										<p>{{ selectedRealEstate()?.address?.zipCode }} {{ selectedRealEstate()?.address?.city }}</p>
									}
								</div>
							</swiper-slide>
							@if (selectedTenantUnit()?.id) {
								<swiper-slide>
									<ng-container>
										<div class="detail-card info-text">
											<h3>
												{{ t('tenantunitDetailsCards.neNr') }}
												{{ selectedTenantUnit()?.number }}
												/{{ selectedTenantUnit()?.subNumber }}
											</h3>
											<p>
												{{ selectedTenantUnit()?.address?.streets[0]?.streetName }}
												{{ selectedTenantUnit()?.address?.streets[0]?.houseNumber }}
											</p>
											<p>{{ beautifyFloor() }}</p>
										</div>
									</ng-container>
								</swiper-slide>
							}
							@if (selectedDevice()?.id) {
								<swiper-slide>
									<ng-container>
										<div class="detail-card info-text">
											<h3>{{ t('tenantunitDetailsCards.deviceDetails') }} {{ selectedDevice()?.deviceNumber }}</h3>
											<p>{{ t('enum.' + selectedDevice()?.deviceType) }}</p>
											<p>{{ t('enum.' + selectedDevice()?.roomType) }}</p>
										</div>
									</ng-container>
								</swiper-slide>
							}
						</swiper-container>
					</div>
				</div>
			</ng-container>
		} @else {
			<ng-container>
				<!-- serviceCompany-Card (immer zuerst im customerportal) -->
				<mat-card
					class="detail-card w-64 flex flex-col m-2 !ml-0 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
					@fadeInUp>
					<mat-card-subtitle class="px-3 pt-2.5 pb-1">
						<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.servicecompany') }}</span>
					</mat-card-subtitle>
					<mat-card-content class="flex-1">
						@if (selectedServiceCompany() === undefined) {
							<div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary"></mat-spinner></div>
						} @else {
							<ng-template *ngTemplateOutlet="companyDetailCard; context: { $implicit: selectedServiceCompany() }"></ng-template>
						}
					</mat-card-content>
				</mat-card>

				<!-- propertyManagement-Card (kein Footer im customerportal) -->
				<mat-card
					class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
					@fadeInUp>
					<mat-card-subtitle class="px-3 pt-2.5 pb-1">
						<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.propertymanagement') }}</span>
					</mat-card-subtitle>
					<mat-card-content class="flex-1">
						@if (selectedPropertyManagement() === undefined) {
							<div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary"></mat-spinner></div>
						} @else {
							<div class="px-2 pb-2">
								<p class="text-xs font-medium leading-relaxed m-0">
									{{ selectedPropertyManagement()?.name ?? selectedPropertyManagement()?.addressField1 }}
								</p>
								<p class="text-xs font-medium leading-relaxed m-0">{{ selectedPropertyManagement()?.addressField2 }}</p>
								<p class="text-xs font-medium leading-relaxed m-0">
									{{ selectedPropertyManagement()?.street }} {{ selectedPropertyManagement()?.houseNumber }}
								</p>
								<p class="text-xs font-medium leading-relaxed m-0">
									{{ selectedPropertyManagement()?.zipCode }} {{ selectedPropertyManagement()?.city }}
								</p>
							</div>
						}
					</mat-card-content>
				</mat-card>

				@if (this.billingsPathSelected()) {
					<!-- LS-Nr Card (billing-units Pfad) – nur GoogleMaps im Footer -->
					<mat-card
						class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
						@fadeInUp>
						<mat-card-subtitle class="px-3 pt-2.5 pb-1">
							@if (selectedRealEstate()?.id) {
								<a [routerLink]="['/realestates', selectedRealEstate()?.id]" class="card-link">
									{{ t('tenantunitDetailsCards.lsNr') }} {{ selectedRealEstate()?.area }}/{{ selectedRealEstate()?.number }}
								</a>
							} @else {
								<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.lsNr') }}</span>
							}
						</mat-card-subtitle>
						<mat-card-content class="flex-1">
							@if (!selectedRealEstate()) {
								<div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary"></mat-spinner></div>
							} @else {
								<div class="px-2 pb-2">
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedRealEstate()?.address?.streets[0]?.streetName }} {{ selectedRealEstate()?.address?.streets[0]?.houseNumber }}
									</p>
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedRealEstate()?.address?.zipCode }} {{ selectedRealEstate()?.address?.city }}
									</p>
								</div>
							}
						</mat-card-content>
						@if (selectedRealEstate()) {
							<div class="card-action-footer flex items-center justify-end gap-0.5 px-2 py-1 border-t border-black/10 bg-black/[0.02]">
								<a
									class="action-btn inline-flex items-center justify-center w-8 h-8 rounded-md border-0 bg-transparent cursor-pointer hover:bg-black/5 transition-colors no-underline"
									[href]="
										'https://www.google.com/maps?q=' +
										(selectedRealEstate()?.address?.streets[0]?.streetName ?? '') +
										'+' +
										(selectedRealEstate()?.address?.streets[0]?.houseNumber ?? '') +
										',+' +
										(selectedRealEstate()?.address?.zipCode ?? '') +
										'+' +
										(selectedRealEstate()?.address?.city ?? '')
									"
									target="_blank"
									(click)="$event.stopPropagation()"
									[matTooltip]="t('address.openInGoogleMaps')"
									matTooltipPosition="above">
									<img src="assets/img/google-maps-icon-2020.svg" alt="Google Maps" class="w-5 h-5 object-contain" />
								</a>
							</div>
						}
					</mat-card>

					<!-- AE-Nr Card (kein Footer im customerportal) -->
					<mat-card
						class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
						@fadeInUp>
						<mat-card-subtitle class="px-3 pt-2.5 pb-1">
							<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.aeNr') }} {{ selectedBilling()?.billingNumber || '' }}</span>
						</mat-card-subtitle>
						<mat-card-content class="flex-1">
							@if (!selectedBilling()?.exportId) {
								<div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary"></mat-spinner></div>
							} @else {
								<div class="px-2 pb-2">
									<p class="text-xs font-medium leading-relaxed m-0">{{ selectedBilling()?.billingName }}</p>
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedBilling()?.startTime | date: 'dd.MM.yyyy' }}
									</p>
								</div>
							}
						</mat-card-content>
					</mat-card>
				} @else {
					<!-- LS-Nr Card (normaler Pfad) – nur GoogleMaps im Footer -->
					<mat-card
						class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
						@fadeInUp>
						<mat-card-subtitle class="px-3 pt-2.5 pb-1">
							@if (selectedRealEstate()?.id) {
								<a [routerLink]="['/realestates', selectedRealEstate()?.id]" class="card-link">
									{{ t('tenantunitDetailsCards.lsNr') }} {{ selectedRealEstate()?.area }}/{{ selectedRealEstate()?.number }}
								</a>
							} @else {
								<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.lsNr') }}</span>
							}
						</mat-card-subtitle>
						<mat-card-content class="flex-1">
							@if (!selectedRealEstate()) {
								<div class="flex justify-center py-4"><mat-spinner diameter="28" color="primary"></mat-spinner></div>
							} @else {
								<div class="px-2 pb-2">
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedRealEstate()?.address?.streets[0]?.streetName }} {{ selectedRealEstate()?.address?.streets[0]?.houseNumber }}
									</p>
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedRealEstate()?.address?.zipCode }} {{ selectedRealEstate()?.address?.city }}
									</p>
								</div>
							}
						</mat-card-content>
						@if (selectedRealEstate()) {
							<div class="card-action-footer flex items-center justify-end gap-0.5 px-2 py-1 border-t border-black/10 bg-black/[0.02]">
								<a
									class="action-btn inline-flex items-center justify-center w-8 h-8 rounded-md border-0 bg-transparent cursor-pointer hover:bg-black/5 transition-colors no-underline"
									[href]="
										'https://www.google.com/maps?q=' +
										(selectedRealEstate()?.address?.streets[0]?.streetName ?? '') +
										'+' +
										(selectedRealEstate()?.address?.streets[0]?.houseNumber ?? '') +
										',+' +
										(selectedRealEstate()?.address?.zipCode ?? '') +
										'+' +
										(selectedRealEstate()?.address?.city ?? '')
									"
									target="_blank"
									(click)="$event.stopPropagation()"
									[matTooltip]="t('address.openInGoogleMaps')"
									matTooltipPosition="above">
									<img src="assets/img/google-maps-icon-2020.svg" alt="Google Maps" class="w-5 h-5 object-contain" />
								</a>
							</div>
						}
					</mat-card>

					@if (selectedTenantUnit()?.id) {
						<!-- NE-Nr Card -->
						<mat-card
							class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
							@fadeInUp>
							<mat-card-subtitle class="px-3 pt-2.5 pb-1 flex items-center justify-between">
								<span class="card-subtitle-text">
									{{ t('tenantunitDetailsCards.neNr') }} {{ selectedTenantUnit()?.number }}/{{ selectedTenantUnit()?.subNumber }}
								</span>
								@if (tenantUnits() === null) {
									<mat-spinner diameter="18" color="primary" class="shrink-0 mx-1"></mat-spinner>
								} @else if ((tenantUnits()?.length ?? 0) > 1) {
									<span class="card-nav-buttons flex items-center">
										<button
											type="button"
											class="nav-btn"
											[disabled]="!canNavigatePrev()"
											(click)="onNavigatorAction('first'); $event.stopPropagation()"
											[matTooltip]="t('tenantunitDetails.navigateToUnit', { unit: getFirstTenantUnitLabel() })"
											matTooltipPosition="above">
											<mat-icon>first_page</mat-icon>
										</button>
										<button
											type="button"
											class="nav-btn"
											[disabled]="!canNavigatePrev()"
											(click)="onNavigatorAction('prev'); $event.stopPropagation()"
											[matTooltip]="t('tenantunitDetails.navigateToUnit', { unit: getPrevTenantUnitLabel() })"
											matTooltipPosition="above">
											<mat-icon>chevron_left</mat-icon>
										</button>
										<button
											#unitSearchBtn
											type="button"
											class="nav-btn"
											(mouseenter)="openTenantUnitPanel(unitSearchBtn)"
											(mouseleave)="onUnitBtnLeave()"
											(click)="openTenantUnitPanel(unitSearchBtn); $event.stopPropagation()"
											[matTooltip]="t('tenantunitDetailsCards.searchTenantUnit')"
											matTooltipPosition="above">
											<mat-icon>person_search</mat-icon>
										</button>
										<button
											type="button"
											class="nav-btn"
											[disabled]="!canNavigateNext()"
											(click)="onNavigatorAction('next'); $event.stopPropagation()"
											[matTooltip]="t('tenantunitDetails.navigateToUnit', { unit: getNextTenantUnitLabel() })"
											matTooltipPosition="above">
											<mat-icon>chevron_right</mat-icon>
										</button>
										<button
											type="button"
											class="nav-btn"
											[disabled]="!canNavigateNext()"
											(click)="onNavigatorAction('last'); $event.stopPropagation()"
											[matTooltip]="t('tenantunitDetails.navigateToUnit', { unit: getLastTenantUnitLabel() })"
											matTooltipPosition="above">
											<mat-icon>last_page</mat-icon>
										</button>
									</span>
								}
							</mat-card-subtitle>
							<mat-card-content class="flex-1">
								<div class="px-2 pb-2">
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ selectedTenantUnit()?.address?.streets[0]?.streetName }}
										{{ selectedTenantUnit()?.address?.streets[0]?.houseNumber }}
									</p>
									<p class="text-xs font-medium leading-relaxed m-0">{{ beautifyFloor() }}</p>
								</div>
							</mat-card-content>
						</mat-card>
					}

					@if (selectedDevice()?.id) {
						<!-- Device Card (kein Footer im customerportal) -->
						<mat-card
							class="detail-card w-64 flex flex-col m-2 rounded-lg shadow-md border border-black/10 overflow-hidden hover:shadow-lg transition-shadow"
							@fadeInUp>
							<mat-card-subtitle class="px-3 pt-2.5 pb-1">
								<span class="card-subtitle-text">{{ t('tenantunitDetailsCards.deviceDetails') }} {{ selectedDevice()?.deviceNumber }}</span>
							</mat-card-subtitle>
							<mat-card-content class="flex-1">
								<div class="px-2 pb-2">
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ t('enum.' + selectedDevice()?.deviceType) }}
									</p>
									<p class="text-xs font-medium leading-relaxed m-0">
										{{ t('enum.' + selectedDevice()?.roomType) }}
									</p>
								</div>
							</mat-card-content>
						</mat-card>
					}
				}
			</ng-container>
		}
	</div>

	<ng-template #companyDetailCardMobile let-company>
		<div class="detail-card info-text" @fadeInUp>
			<p>{{ company?.company?.companyNames[0]?.name }}</p>
			<p>{{ company?.company?.companyNames[1]?.name }}</p>
			<p>{{ company?.address?.streets[0]?.streetName }} {{ company?.address?.streets[0]?.houseNumber }}</p>
			<p>{{ company?.address?.zipCode }} {{ company?.address?.city }}</p>
		</div>
	</ng-template>

	<ng-template #companyDetailCard let-company>
		<div class="px-2 pb-2" @fadeInUp>
			<div class="flex flex-row items-start">
				@if (sessionService.cachedFavIconsByArea.has(selectedRealEstate()?.area)) {
					<img [src]="getIconUrl(selectedRealEstate()?.area)" alt="Icon" width="32" height="32" class="mr-2 shrink-0" />
				}
				<div>
					<p class="text-xs font-medium leading-relaxed m-0">{{ company?.company?.companyNames[0]?.name }}</p>
				</div>
			</div>
			<p class="text-xs font-medium leading-relaxed m-0">{{ company?.company?.companyNames[1]?.name }}</p>
			<p class="text-xs font-medium leading-relaxed m-0">
				{{ company?.address?.streets[0]?.streetName }} {{ company?.address?.streets[0]?.houseNumber }}
			</p>
			<p class="text-xs font-medium leading-relaxed m-0">{{ company?.address?.zipCode }} {{ company?.address?.city }}</p>
		</div>
	</ng-template>
</div>
